import React from 'react';
import cn from 'classnames';
import { observer } from 'mobx-react';

import { RecordIcon } from 'components/presenters/icons';
import ActionButton from 'components/widgets/ActionButton/ActionButton';
import { ActionButtonTypesEnum } from 'interface';

import { useRecordButtonHooksCombiner } from './hooks/useRecordButtonHooksCombiner';
import RecordButtonPopup from './RecordButtonPopup/RecordButtonPopup';
import { RecordButtonProps, useRecordButtonHooksCombinerOutputProps } from './interface';

import styles from './RecordButton.module.scss';

function RecordButton({
  assetId,
  seriesId,
  disabled,
  className,
  programNotAvailable,
  callback,
  enableCatchUp,
}: RecordButtonProps) {
  const {
    record,
    seriesRecord,
    pending,
    isMenuOpen,
    isActiveRecordIcon,
    isMultipleRecordIcon,
    buttonLabel,
    ref,
    handleMenuBtnClick,
    handleRecordBtnClick,
  } = useRecordButtonHooksCombiner({
    assetId,
    seriesId,
    programNotAvailable,
    callback,
    enableCatchUp,
  }) as useRecordButtonHooksCombinerOutputProps;

  return (
    <div className={styles.wrapper}>
      {isMenuOpen && (
        <RecordButtonPopup
          isRecord={!!record}
          isSeriesRecord={!!seriesRecord}
          isActiveRecordIcon={isActiveRecordIcon}
          onClick={handleMenuBtnClick}
        />
      )}

      <ActionButton
        className={cn(className, {
          [styles.active]: isMenuOpen,
          [styles.hidden]: pending
        })}
        data-disabled={disabled ? 'disabled' : null}
        disabled={disabled}
        title={buttonLabel}
        icon={
          <RecordIcon
            active={isActiveRecordIcon}
            className={cn({ [styles.recordIcon]: !!seriesRecord, [styles.pending]: pending })}
            multiple={isMultipleRecordIcon}
            pending={pending}
          />
        }
        isLarge
        onClick={handleRecordBtnClick}
        type={ActionButtonTypesEnum.secondary}
        forwardRef={ref}
      />
    </div>
  );
}

export default observer(RecordButton);
